<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import appConfig from "@/app.config";
// import api from "../../../api";
import AnalyticsResult from "./AnalyticsResult.vue";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Analytics",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Heading,
    AnalyticsResult,
  },
  async beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave", this.$route.name, from);

    if (this.resultview) {
      console.log("analytics", this.$refs["analytics"].isObjectChanged());
      if (this.$refs["analytics"].isObjectChanged()) {
        const { isConfirmed } = await Swal.fire({
          title: "You have unsaved changes.",
          text: "Please save your changes before switching to next topic.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Discard changes",
        });
        console.log("isConfirmed", isConfirmed);
        if (isConfirmed) {
          next();
        } else {
          next(false);
        }
      } else {
        next();
      }
    } else {
      next();
    }

    // Ask user if they want to leave the page
  },
  methods: {
    openAnalytics() {
      window.open(
        "https://lookerstudio.google.com/reporting/aa255838-8dcc-471a-9743-bd856aec3e1a/page/NBx2C",
        "_blank"
      );
    },
    checkPracticeName(inputName) {
      if (inputName) {
        const normalizedInput = inputName.trim().toLowerCase();
        return this.websiteAnalyticsPracticsName.some(
          (practice) => practice.toLowerCase() === normalizedInput
        );
      }
      return false;
    },
  },
  mounted() {},
  data() {
    return {
      websiteAnalyticsPracticsName: [
        "Bharani Medical Centre",
        "Claremont Holyport Surgery",
        "Hart Health Partnership",
        "Ragstone Road Surgery",
        "Ringmead Medical Practice",
        "Dedworth Medical Centre & South Meadow Surgery",
        "Oakley Health Group",
        "Sandhurst Group Practice",
        "Claremont & Holyport Surgeries",
        "Dr Sharma's Surgery",
        "240 Wexham Road",
        "Bartlett Group Practice",
        "Bharani Medical Centre (Ragstone)",
        "Camberley Health Centre",
        "Cippenham Surgery",
        "Claremont Holyport Surgery",
        "Clarence Medical Centre",
        "Cookham Medical Centre",
        "Cordwallis Road Surgery",
        "Crondall New Surgery",
        "Crosby House Surgery",
        "Crown Wood Medical Centre",
        "Datchet Health Centre",
        "Downing Street Group Practice",
        "Easthampstead Surgery",
        "Evergreen Practice",
        "Farnham Dene Medical Practice",
        "Farnham Park Health Group",
        "Farnham Road Practice",
        "Great Hollands Practice",
        "Green Meadows Surgery",
        "Hart Health Partnership (Brank)",
        "Herschel Medical Centre",
        "Holly Tree Surgery",
        "Kings Corner Surgery",
        "Kumar Medical Centre",
        "Langley Health Centre",
        "Lee House Surgery",
        "Linden Medical Centre",
        "Magnolia House Surgery",
        "Manor Park Medical Centre",
        "Mayfield Medical Centre",
        "North Camp Surgery",
        "Park House Surgery",
        "Park Road Group Practice",
        "Ragstone Road Surgery (Bharani)",
        "Redwood House Surgery",
        "Richmond Surgery",
        "Ringmead Medical Practice (Sandhurst)",
        "Ross Road Medical Centre",
        "Runnymede Medical Practice",
        "Sheet Street Surgery",
        "Shreeji Medical Centre",
        "South Meadow Surgery",
        "Station Road Surgery",
        "The Avenue Medical Centre",
        "The Cedars Surgery",
        "The Oakley Health Group",
        "The Orchard Surgery",
        "The Sandhurst Group Practice",
        "The Village Medical Centre (Frimley)",
        "The Waterfield Practice",
        "Upper Gordon Road Surgery",
        "Voyager Family Health",
        "Wexham Road Surgery",
        "Woodlands Park Surgery",
      ],
      docs: [],
      page: {
        title: "Analytics",
        lastUpdated: "31 Dec 2020 15:00",
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
      },
    };
  },
  computed: {
    resultview() {
      return this.$route.name === "analyticsresult";
    },
  },
};
</script>

<template>
  <Layout>
    <template v-if="!resultview">
      <Heading :page="page"></Heading>
      <div class="pl-page-container pt-0">
        <div>
          <div class="row p-0 mt-4" style="letter-spacing: 0.02em">
            <div class="col-md-2">
              <div
                class="text-dark cursor-pointer"
                @click="$router.push({ name: 'analyticsresult' })"
              >
                <div class="card align-items-center">
                  <div class="card-body p-0">
                    <div class="text-primary font-size-50">
                      <span>
                        <img src="@/assets/images/smiley.svg" />
                      </span>
                    </div>
                  </div>
                  <div class="card-body p-0 pt-2 pb-3 text-center">
                    <p class="mx-auto text-uppercase m-0 font-weight-medium">
                      {{ "FFT Results" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-2"
              v-if="checkPracticeName(currentPractice.name)"
            >
              <div class="text-dark cursor-pointer" @click="openAnalytics">
                <div class="card align-items-center">
                  <div class="card-body p-0">
                    <div class="text-primary font-size-50">
                      <span>
                        <img src="@/assets/images/analytics-blue.svg" />
                      </span>
                    </div>
                  </div>
                  <div class="card-body p-0 pt-2 pb-3 text-center">
                    <p class="mx-auto text-uppercase m-0 font-weight-medium">
                      {{ "Website Analytics" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="pl-page-container p0" v-else>
      <AnalyticsResult ref="analytics"></AnalyticsResult>
    </div>
  </Layout>
</template>
<style scoped>
.p0 {
  padding: 0px;
}
</style>
